import React from 'react';
import { Box } from '@/shared/ui/box';
import { BodyTextMediumB, HeadingBoldH4 } from '@/shared/ui/typography2';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';

const TitlePrepared = ({ mobileLandscape }) => (
  <Box $padding={['8px 10px', 0]} $marginBottom={['18px', '12px']}>
    {mobileLandscape ? (
      <BodyTextMediumB>Alegeți bonusul</BodyTextMediumB>
    ) : (
      <HeadingBoldH4>Alegeți bonusul</HeadingBoldH4>
    )}
  </Box>
);

const TitlePreparedWithBreakpointSlice = withBreakpointsSlice(
  TitlePrepared,
  ({ mobileLandscape }) => ({ mobileLandscape })
);

export { TitlePreparedWithBreakpointSlice as TitlePrepared };
